// services/ManagerDashboardService.js
import http from "./Http";

/**
 * Gets the dashboard summary with total active stores, archived stores, total orders, and total transaction amount.
 *
 * @param {string} [subscriptionPlanId] - Optional subscription plan ID to filter results.
 * @returns {Promise<Object>} Dashboard summary data
 */
const getDashboardSummary = async (subscriptionPlanId = "") => {
    const params = new URLSearchParams();

    if (subscriptionPlanId !== "") {
        params.append("subscriptionPlanId", subscriptionPlanId);
    }

    const queryString = params.toString();
    const url = `/manager/dashboard-summary${queryString ? `?${queryString}` : ""}`;

    const res = await http.get(url);
    return res.data;
};

/**
 * Exports the orders report and returns the file path.
 *
 * @param {Object} filters - Filters for the report (optional)
 * @param {string} [filters.startDate] - Start date (YYYY-MM-DD)
 * @param {string} [filters.endDate] - End date (YYYY-MM-DD)
 * @param {string|number} [filters.dealerId] - Dealer ID
 * @returns {Promise<string>} File path of the generated Excel
 */
const exportOrdersReport = async ({ startDate = "", endDate = "", dealerId = "" } = {}) => {
    const params = new URLSearchParams();

    if (startDate) params.append("startDate", startDate);
    if (endDate) params.append("endDate", endDate);
    if (dealerId) params.append("dealerId", dealerId);

    const queryString = params.toString();
    const url = `/manager/orders-report-export${queryString ? `?${queryString}` : ""}`;

    const res = await http.get(url);
    return res.data;
};

const ManagerDashboardService = {
    getDashboardSummary,
    exportOrdersReport,
};

export default ManagerDashboardService;
